export const SET_SITES = 'SET_SITES';
export const SET_DRAGGED_SITE = 'SET_DRAGGED_SITE';
export const SET_GLOBAL_LOCATIONS = 'SET_GLOBAL_LOCATIONS';
export const SET_IGNORE_FOCUSED = 'SET_IGNORE_FOCUSED';
export const SET_IS_LOADING_SITES = 'SET_IS_LOADING_SITES';
